import type { Attribute } from "../sign-up-request";
import { css, styled, Typography } from "@mui/material";
import phoneCss from "bundle-text:@charterindex/armoury-www/telephone-number-input.css";
import { type JSX } from "react";
import { AttributeTextField, AttributePhoneField } from "../components";
import { SignUpStep } from "../step";
import { useAutofocus } from "../util";


export class UserDetailsStep extends SignUpStep {
	override title: string = "Your Details";
	override view: () => JSX.Element = () => <UserDetailsStepView step={ this }/>;

	get firstName(): Attribute<string> {
		return this.app.state.attribute("firstName");
	}
	get lastName(): Attribute<string> {
		return this.app.state.attribute("lastName");
	}
	get phone(): Attribute<string> {
		return this.app.state.attribute("phone");
	}

	protected override handleSubmit(): Promise<void> {
		this.app.onUserDetailsProvided();
		return Promise.resolve();
	}
}

const UserDetailsStepFields = styled("div")(({ theme }) => css`
	display: flex;
	flex-direction: column;
	gap: ${theme.spacing(1)};

	${theme.breakpoints.up("sm")} {
		display: grid;
		grid-template-columns: 1fr 1fr;
		gap: ${theme.spacing(1)};
	}
	
	.fullWidth {
		grid-column: 1 / -1;
	}
	
	margin: auto 0;
`);


const UserDetailsStepView = (p: { step: UserDetailsStep; }): JSX.Element => {
	const autofocus = useAutofocus();

	return (
		<>
			<style dangerouslySetInnerHTML={{ __html: phoneCss }}/>
			<Typography component="p">
				Provide some details about yourself.
			</Typography>

			<UserDetailsStepFields>
				<AttributeTextField
					name="firstName"
					label="First Name"
					inputRef={ autofocus }
					attribute={ p.step.firstName }
					required
				/>
				<AttributeTextField
					name="lastName"
					label="Last Name"
					attribute={ p.step.lastName }
					required
				/>
				<AttributePhoneField attribute={ p.step.phone }/>
			</UserDetailsStepFields>
		</>
	);
};
